const findSiblingEvaluation = (fechaAplicacion, evaluationsToCheck) => {
  try {
    const siblingEvaluation = evaluationsToCheck.find((evaluation) => evaluation.fechaAplicacion === fechaAplicacion)

    if (siblingEvaluation) {
      return siblingEvaluation
    }

    return null
  } catch (error) {
    console.error('Error finding sibling evaluation:', error)
    return null
  }
}

export default findSiblingEvaluation
